// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-users.modal-verificate{
    width: 100% !important;
    height: 99% !important;
}
.content-card-users{
  height: 94%;
}
.txt-title-user-box-Mantto.modal-verificate{
    text-align: center;
    word-wrap: break-word;
    width: 80%;
}

.user-box-Mantto {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
}
.form-Mantto-box {
    position: relative;
    display: block;
    width: 80%;
    height: 90%;
  }
.form-Mantto-box .user-box-Mantto .label-Mantto {
    position: absolute;
    top: 0px !important;
    left: 0;
    padding: 10px 0;
    font-size: 10px !important;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  .form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto, .form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto {
    top: -25px !important;
    left: 0px;
    color: #003757;
    font-size: 12px;
  }



  
  .form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto,
.form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto,
.form-Mantto-box .user-box-Mantto .active {
    top: -25px !important;
    left: 0px;
    font-size: 12px;
}


.form-Mantto-box .user-box-Mantto input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #505050;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
}

.form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto,
.form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto {
  top: -10px;
  left: 0;
  color: #003757;
  font-size: 12px;
}
.form-msg-error{
  color: #ff4646;
  position: absolute;
  left:0;
  /* top:10% */
  bottom: 5%;
  background-color: rgba(255, 211, 211, 0.64);
  width: 99%;
  text-align: center;
  border: 2px solid #ff4646;
  border-radius: 0px 0px 5px 5px;
  
  border-top: none;

}
.head-card-Mantto {
  position: relative;
  height: 5%;
  width: 100%;
  background: rgba(195,195,195);
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkbox-Mantto{
  height: 25px !important;
  
}
.checkbox-Mantto:hover{
  cursor: pointer;
}
.label-checkbox-Mantto{
  left: 55%;
  position: absolute;
  top: 10%;
  color:#003757
}





.container-searchHostMantto-list{
  /* background-color: #2c305cbd; */
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  justify-content: center;
  max-height: 150px;
  font-size: x-small;
  top: 60%;
  z-index: 3;
  border: 1px solid white;
}
.compact-searchHostMantto-list{
    
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: relative;
  display: block;
  overflow: scroll;
  border: 1px solid rgba(240, 248, 255, 0.575) !important;
  border-radius: 5px;
}
.row-searchHostMantto-list{
  background-color: #203969;

position: relative;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 30px;
/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */
color: #72c1fa;
}
.row-searchHostMantto-list:hover{
  background-color: aliceblue;
  cursor: pointer;
}
.cont-row-searchHostMantto-txt{
  display: flex;
  justify-content: center;
}
.ip-row-searchHostMantto{
  color: aliceblue;
}
.row-searchHostMantto-list:hover .ip-row-searchHostMantto {
  color: #34373c;
}
.closeListSearch{
  position: absolute;
  top: -20%;
  left: 100%;
  width: 10%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  font-weight: bolder;
  font-size: medium;
}
.closeListSearch:hover{
  font-size: larger;
  cursor: pointer;
}

.read{
  background: #dbdbdb;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/MediosDifusion/GruposTelegram/styles/ModalCreateException.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;EACE,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;EACb;AACF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;;;;EAKA;;;IAGE,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;;EAE9B,gBAAgB;;AAElB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR;AACF;;;;;;AAMA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uDAAuD;EACvD,kBAAkB;AACpB;AACA;EACE,yBAAyB;;AAE3B,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,0DAA0D;AAC1D,cAAc;AACd;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".card-users.modal-verificate{\r\n    width: 100% !important;\r\n    height: 99% !important;\r\n}\r\n.content-card-users{\r\n  height: 94%;\r\n}\r\n.txt-title-user-box-Mantto.modal-verificate{\r\n    text-align: center;\r\n    word-wrap: break-word;\r\n    width: 80%;\r\n}\r\n\r\n.user-box-Mantto {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 20%;\r\n}\r\n.form-Mantto-box {\r\n    position: relative;\r\n    display: block;\r\n    width: 80%;\r\n    height: 90%;\r\n  }\r\n.form-Mantto-box .user-box-Mantto .label-Mantto {\r\n    position: absolute;\r\n    top: 0px !important;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 10px !important;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  .form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto, .form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    color: #003757;\r\n    font-size: 12px;\r\n  }\r\n\r\n\r\n\r\n  \r\n  .form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto,\r\n.form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto,\r\n.form-Mantto-box .user-box-Mantto .active {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    font-size: 12px;\r\n}\r\n\r\n\r\n.form-Mantto-box .user-box-Mantto input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: #505050;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-bottom: 2px solid #003757;\r\n  border-right: 2px solid #003757;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.form-Mantto-box .user-box-Mantto input:focus ~ .label-Mantto,\r\n.form-Mantto-box .user-box-Mantto input:valid ~ .label-Mantto {\r\n  top: -10px;\r\n  left: 0;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n.form-msg-error{\r\n  color: #ff4646;\r\n  position: absolute;\r\n  left:0;\r\n  /* top:10% */\r\n  bottom: 5%;\r\n  background-color: rgba(255, 211, 211, 0.64);\r\n  width: 99%;\r\n  text-align: center;\r\n  border: 2px solid #ff4646;\r\n  border-radius: 0px 0px 5px 5px;\r\n  \r\n  border-top: none;\r\n\r\n}\r\n.head-card-Mantto {\r\n  position: relative;\r\n  height: 5%;\r\n  width: 100%;\r\n  background: rgba(195,195,195);\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.checkbox-Mantto{\r\n  height: 25px !important;\r\n  \r\n}\r\n.checkbox-Mantto:hover{\r\n  cursor: pointer;\r\n}\r\n.label-checkbox-Mantto{\r\n  left: 55%;\r\n  position: absolute;\r\n  top: 10%;\r\n  color:#003757\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.container-searchHostMantto-list{\r\n  /* background-color: #2c305cbd; */\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  max-height: 150px;\r\n  font-size: x-small;\r\n  top: 60%;\r\n  z-index: 3;\r\n  border: 1px solid white;\r\n}\r\n.compact-searchHostMantto-list{\r\n    \r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: block;\r\n  overflow: scroll;\r\n  border: 1px solid rgba(240, 248, 255, 0.575) !important;\r\n  border-radius: 5px;\r\n}\r\n.row-searchHostMantto-list{\r\n  background-color: #203969;\r\n\r\nposition: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nwidth: 100%;\r\nheight: 30px;\r\n/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */\r\ncolor: #72c1fa;\r\n}\r\n.row-searchHostMantto-list:hover{\r\n  background-color: aliceblue;\r\n  cursor: pointer;\r\n}\r\n.cont-row-searchHostMantto-txt{\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.ip-row-searchHostMantto{\r\n  color: aliceblue;\r\n}\r\n.row-searchHostMantto-list:hover .ip-row-searchHostMantto {\r\n  color: #34373c;\r\n}\r\n.closeListSearch{\r\n  position: absolute;\r\n  top: -20%;\r\n  left: 100%;\r\n  width: 10%;\r\n  height: 70%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: red;\r\n  font-weight: bolder;\r\n  font-size: medium;\r\n}\r\n.closeListSearch:hover{\r\n  font-size: larger;\r\n  cursor: pointer;\r\n}\r\n\r\n.read{\r\n  background: #dbdbdb;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
